/* covered.ro — Cum se aplică: progress line + active steps on scroll */
(() => {
  if (customElements.get('cv-steps')) return;

  const clamp = (v) => Math.min(1, Math.max(0, v));
  const supportsScrollTimeline =
    typeof CSS !== 'undefined' && CSS.supports && CSS.supports('animation-timeline: view()');

  class CvSteps extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.cv-steps__rail');
      this.track = this.querySelector('.cv-steps__track');
      this.steps = Array.from(this.querySelectorAll('.cv-steps__step'));
      if (!this.rail || !this.track || this.steps.length === 0) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.vertical = window.matchMedia('(max-width: 767.98px)');
      this.thresholds = [];

      this.setup = this.setup.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      if (this.reduceMotion.addEventListener) {
        this.reduceMotion.addEventListener('change', this.setup);
        this.vertical.addEventListener('change', this.onResize);
      }
      this.setup();
    }

    disconnectedCallback() {
      this.teardown();
      if (this.reduceMotion && this.reduceMotion.removeEventListener) {
        this.reduceMotion.removeEventListener('change', this.setup);
        this.vertical.removeEventListener('change', this.onResize);
      }
    }

    get isStatic() {
      return (
        this.hasAttribute('data-static') ||
        this.reduceMotion.matches ||
        document.body.classList.contains('disable-animations')
      );
    }

    setup() {
      this.teardown();
      if (this.isStatic) {
        this.removeAttribute('data-animate');
        this.removeAttribute('data-scroll-timeline');
        this.style.removeProperty('--cv-steps-p');
        this.steps.forEach((step) => step.classList.add('is-active'));
        return;
      }
      this.setAttribute('data-animate', '');
      // The line itself runs on the compositor when the browser supports
      // scroll timelines; JS still lights the steps as the line reaches them.
      if (supportsScrollTimeline) this.setAttribute('data-scroll-timeline', '');
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.onResize();
    }

    teardown() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      cancelAnimationFrame(this.frame);
      this.ticking = false;
    }

    onResize() {
      if (this.isStatic) return;
      const isVertical = this.vertical.matches;
      const track = this.track.getBoundingClientRect();
      this.thresholds = this.steps.map((step) => {
        const node = step.querySelector('.cv-steps__node') || step;
        const rect = node.getBoundingClientRect();
        return isVertical
          ? (rect.top + rect.height / 2 - track.top) / Math.max(1, track.height)
          : (rect.left + rect.width / 2 - track.left) / Math.max(1, track.width);
      });
      this.render();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      this.frame = requestAnimationFrame(() => {
        this.ticking = false;
        this.render();
      });
    }

    progress() {
      const rect = this.rail.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      if (this.vertical.matches) return clamp((0.7 * vh - rect.top) / Math.max(1, rect.height));
      return clamp((0.8 * vh - rect.top) / (0.45 * vh));
    }

    render() {
      const p = this.progress();
      if (!supportsScrollTimeline) this.style.setProperty('--cv-steps-p', p.toFixed(4));
      this.steps.forEach((step, index) => {
        const reached = p > 0 && p >= (this.thresholds[index] || 0) - 0.015;
        step.classList.toggle('is-active', reached);
      });
    }
  }

  customElements.define('cv-steps', CvSteps);
})();
